var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1TruckParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 37v14H0v12h4.15a7 7 0 0113.42-2.76A7 7 0 0131 63h23a7 7 0 1114 0h4V53c0-6.67-5.31-16-5.31-16H56zm4 11v-7h4.86a17 17 0 012 7H60zm9.1-39.5a2.5 2.5 0 01-2.5 2.5H63V6h3.58a2.5 2.5 0 012.5 2.5h.02zM55 0v22h21V0H55zm11.58 14H63v5h-3V3h6.58a5.5 5.5 0 010 11zM65 63a4 4 0 11-8 0 4 4 0 018 0zM53 25H0v23h53V25zm-4 19H4V29h45v15zM28 63a4 4 0 11-8 0 4 4 0 018 0zm-12.86 0a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Truck_parking.3375aaaf.svg";
export { SvgI1TruckParking as ReactComponent };